import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 36, className = "", amount = 0.2 }) {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount, margin: "0px 0px -60px 0px" }}
            transition={{ duration: 1, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function Eyebrow({ children, light = false }) {
    return (
        <p
            className={`flex items-center gap-3 text-xs font-light uppercase tracking-[0.35em] ${
                light ? "text-white/70" : "text-slate-400"
            }`}
        >
            <span className={`h-px w-8 ${light ? "bg-white/50" : "bg-slate-300"}`} />
            {children}
        </p>
    );
}

// Editorial image treatment: settles in on scroll, sits monochrome until hovered.
export function EditorialImg({ src, alt, className = "", reveal = true }) {
    const reduce = useReducedMotion();
    if (!reveal) {
        return (
            <div className={`group overflow-hidden ${className}`}>
                <img
                    src={src}
                    alt={alt}
                    loading="lazy"
                    className="h-full w-full object-cover grayscale transition-[filter,transform] duration-700 ease-out group-hover:scale-[1.04] group-hover:grayscale-0"
                />
            </div>
        );
    }
    return (
        <motion.div
            className={`overflow-hidden ${className}`}
            initial={reduce ? { opacity: 0 } : { opacity: 0, scale: 1.03 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1.2, ease: EASE }}
        >
            <div className="group h-full w-full overflow-hidden">
                <motion.img
                    src={src}
                    alt={alt}
                    loading="lazy"
                    initial={reduce ? { scale: 1 } : { scale: 1.18 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true, amount: 0.15 }}
                    transition={{ duration: 1.6, ease: EASE }}
                    className="h-full w-full object-cover grayscale transition-[filter,transform] duration-700 ease-out group-hover:scale-[1.04] group-hover:grayscale-0"
                />
            </div>
        </motion.div>
    );
}
